'use strict';

function parse(reader) {
    reader.readUInt16LE('data.params.execInterval');
    reader.readUInt16LE('data.params.maxRespTime');
    reader.readUInt16LE('data.params.maxRetries');
}

module.exports.parse = parse;



// WEBPACK FOOTER //
// ./src/lib/ucp/parsers/mode/cloud/v1_3/common/rule/uart-channel-collect-parser.js